import { ValueByOrderType } from 'state/workspaces/secondary-market/batch/model';

export const equalsById = (obj1?: ValueByOrderType | null, obj2?: ValueByOrderType | null) => {
  return (obj1 as { id: unknown })?.id === (obj2 as { id: unknown })?.id;
};
